<pf-loading-overlay />
<div class="add-product-event__header">
    <h3>{{ 'admin.product.event.title.addNewEvent' | translate }}:</h3>
</div>
<div class="add-product-event__toolbar">
    <div class="add-product-event__toolbar-actions">
        <button class="add-product-event__btn-cancel" type="button" (click)="navigateBack()">
            <mat-icon>cancel</mat-icon>
            {{ 'admin.product.event.button.cancel' | translate }}
        </button>
        <button class="add-product-event__btn-save" type="button" [disabled]="!productEventRegistrationList.length" (click)="onSaveList()">
            <mat-icon>save</mat-icon>
            {{ 'admin.product.event.button.save' | translate }}
        </button>
    </div>
</div>
<div class="add-product-event__container">
    <div class="add-product-event__content" [class.add-product-event__content--has-table]="productEventDisplayList.length > 0">
        <div class="add-product-event__form-column">
            <form [formGroup]="addProductEvent">
                <div class="add-product-event__field--event-type">
                    <label>{{ 'admin.product.event.field.eventType' | translate }}:</label>
                    <pf-select
                        #firstField
                        [options]="eventTypeOptions()"
                        (singleSelectionChange)="onEventTypeSelect($event)"
                    />
                </div>

                @if (isFieldVisible('fromStorageType')) {
                    <div class="add-product-event__field">
                        <label>{{ 'admin.product.event.field.fromStorage' | translate }}:</label>
                        <pf-select
                            [options]="storageTypeOptions()"
                            [initialSelectedId]="initialFromStorageTypeId()"
                            (singleSelectionChange)="onFromStorageTypeSelect($event)"
                        />
                    </div>
                }
                @if (isFieldVisible('toStorageType')) {
                    <div class="add-product-event__field">
                        <label>{{ 'admin.product.event.field.toStorage' | translate }}:</label>
                        <pf-select
                            [options]="storageTypeOptions()"
                            [initialSelectedId]="initialToStorageTypeId()"
                            (singleSelectionChange)="onToStorageTypeSelect($event)"
                        />
                    </div>
                }
                @if (isFieldVisible('productId')) {
                    <div class="add-product-event__field">
                        <label>{{ 'admin.product.event.field.productName' | translate }}:</label>
                        <pf-select
                            [options]="productSelectOptions()"
                            [initialSelectedId]="initialProductId()"
                            (singleSelectionChange)="onProductSelect($event)"
                        />
                    </div>
                }
                @if (isFieldVisible('festivalId')) {
                    <div class="add-product-event__field">
                        <label>{{ 'admin.product.event.field.festivalName' | translate }}:</label>
                        <pf-select
                            [options]="festivalSelectOptions()"
                            [initialSelectedId]="initialFestivalId()"
                            (singleSelectionChange)="onFestivalSelect($event)"
                        />
                    </div>
                }
                @if (isFieldVisible('partnerId')) {
                    <div class="add-product-event__field">
                        <label>{{ 'admin.product.event.field.partnerName' | translate }}:</label>
                        <pf-select
                            [options]="partnerSelectOptions()"
                            [initialSelectedId]="initialPartnerId()"
                            (singleSelectionChange)="onPartnerSelect($event)"
                        />
                    </div>
                }
                @if (isFieldVisible('orderDetailsReference')) {
                    <div class="add-product-event__field">
                        <label>{{ 'admin.product.event.field.orderDetailsReference' | translate }}:</label>
                        <input type="text" formControlName="orderDetailsReference" />
                    </div>
                }
                @if (isFieldVisible('productReference')) {
                    <div class="add-product-event__field">
                        <label>{{ 'admin.product.event.field.productReference' | translate }}:</label>
                        <input type="text" formControlName="productReference" />
                    </div>
                }
                @if (isFieldVisible('quantity')) {
                    <div class="add-product-event__field">
                        <label>{{ 'admin.product.event.field.quantity' | translate }}:</label>
                        <input type="number" formControlName="quantity" />
                    </div>
                }
                @if (isFieldVisible('unitPrice')) {
                    <div class="add-product-event__field">
                        <label>{{ 'admin.product.event.field.unitPrice' | translate }}:</label>
                        <input type="number" formControlName="unitPrice" />
                    </div>
                }
                @if (isFieldVisible('eventDate')) {
                    <div class="add-product-event__field">
                        <label>{{ 'admin.product.event.field.eventDate' | translate }}:</label>
                        <pf-datepicker [maxDate]="maxDate" [initialDate]="defaultEventDate" (selectedDate)="onEventDateSelected($event)" />
                    </div>
                }
                @if (isFieldVisible('comment')) {
                    <div class="add-product-event__field">
                        <label>{{ 'admin.product.event.field.comment' | translate }}:</label>
                        <textarea rows="4" cols="50" formControlName="comment"></textarea>
                    </div>
                }
                @if (selectedProductEventTypeOption !== null) {
                    <div class="add-product-event__form-actions">
                        <button
                            class="add-product-event__btn-add"
                            type="button"
                            [disabled]="addProductEvent.invalid"
                            (click)="onSubmitListElement()">
                            <mat-icon>playlist_add</mat-icon>
                            {{
                                (editingIndex() !== null
                                    ? 'admin.product.event.button.updateEvent'
                                    : 'admin.product.event.button.addNewEvent'
                                ) | translate
                            }}
                        </button>
                    </div>
                }
            </form>
        </div>
        @if (productEventDisplayList.length > 0) {
            <div class="add-product-event__table-column">
                <table>
                    <thead>
                        <tr>
                            <th>{{ 'admin.product.event.field.eventType' | translate }}</th>
                            <th>{{ 'admin.product.event.field.fromStorage' | translate }}</th>
                            <th>{{ 'admin.product.event.field.toStorage' | translate }}</th>
                            <th>{{ 'admin.product.event.field.productName' | translate }}</th>
                            <th>{{ 'admin.product.event.field.festivalName' | translate }}</th>
                            <th>{{ 'admin.product.event.field.partnerName' | translate }}</th>
                            <th>{{ 'admin.product.event.field.referenceNumber' | translate }}</th>
                            <th>{{ 'admin.product.event.field.quantity' | translate }}</th>
                            <th>{{ 'admin.product.event.field.unitPrice' | translate }}</th>
                            <th>{{ 'admin.product.event.field.eventDate' | translate }}</th>
                            <th>{{ 'admin.product.event.field.comment' | translate }}</th>
                            <th>{{ 'admin.product.event.field.action' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (productEvent of productEventDisplayList; track $index; let i = $index) {
                            <tr
                                class="add-product-event__table-row"
                                [class.add-product-event__table-row--editing]="editingIndex() === i">
                                <td
                                    [attr.title]="
                                        'admin.product.event.type.' + getProductEventTypeDisplayValue(productEvent.productEventType)
                                            | translate
                                    ">
                                    {{
                                        'admin.product.event.type.' + getProductEventTypeDisplayValue(productEvent.productEventType)
                                            | translate
                                    }}
                                </td>
                                <td
                                    [attr.title]="
                                        'admin.product.event.storage.' + getStorageTypeDisplayValue(productEvent.fromStorageType)
                                            | translate
                                    ">
                                    {{
                                        'admin.product.event.storage.' + getStorageTypeDisplayValue(productEvent.fromStorageType)
                                            | translate
                                    }}
                                </td>
                                <td
                                    [attr.title]="
                                        'admin.product.event.storage.' + getStorageTypeDisplayValue(productEvent.toStorageType) | translate
                                    ">
                                    {{
                                        'admin.product.event.storage.' + getStorageTypeDisplayValue(productEvent.toStorageType) | translate
                                    }}
                                </td>
                                <td [attr.title]="productEvent.productName">{{ productEvent.productName }}</td>
                                <td [attr.title]="productEvent.festivalName">{{ productEvent.festivalName }}</td>
                                <td [attr.title]="productEvent.partnerName">{{ productEvent.partnerName }}</td>
                                <td [attr.title]="productEvent.referenceNumber">{{ productEvent.referenceNumber }}</td>
                                <td [attr.title]="productEvent.quantity">{{ productEvent.quantity | number: '1.0-0' : 'hu-HU' }}</td>
                                <td [attr.title]="productEvent.unitPrice">{{ productEvent.unitPrice | number: '1.0-0' : 'hu-HU' }}</td>
                                <td [attr.title]="productEvent.eventDate">{{ toDateArray(productEvent.eventDate) | dateUtil }}</td>
                                <td [attr.title]="productEvent.comment">{{ productEvent.comment }}</td>
                                <td>
                                    <div class="add-product-event__row-actions">
                                        <button class="add-product-event__row-action-btn" type="button" (click)="onEditListElement(i)">
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                        <button class="add-product-event__row-action-btn delete-btn" type="button" (click)="onDeleteListElement(i)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
    </div>
</div>
